export default __webpack_public_path__ + "static/media/2412313.7668e314.webp";